import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { ImageInterface } from 'ech-components/src/types';

export type CampaignNavigationInterface = {
  node_locale: string;
  slug: string;
  campaignKey: string;
  campaignName: string;
  mainHub: {
    title: string;
    slug: string;
  };
  teaser: string;
  groupName1: string;
  groupNavigation1: {
    __typename: string;
    node_locale: string;
    slug: string;
    navigationTitle: string;
    teaserImage: ImageInterface;
  }[];
  groupName2: string;
  groupNavigation2: {
    __typename: string;
    node_locale: string;
    slug: string;
    navigationTitle: string;
    teaserImage: ImageInterface;
  }[];
  groupName3: string;
  groupNavigation3: {
    __typename: string;
    node_locale: string;
    slug: string;
    navigationTitle: string;
  }[];
  legalText: {
    __typename: string;
    node_locale: string;
    slug: string;
    navigationTitle: string;
  }[];
  defaultPicture: {
    gatsbyImageData: IGatsbyImageData;
  };
};

type QueryResponse = {
  allContentfulCampaignConfiguration: {
    nodes: CampaignNavigationInterface[];
  };
};

export const useNavigationQuery = () => {
  const { allContentfulCampaignConfiguration } =
    useStaticQuery<QueryResponse>(graphql`
      query NavigationQuery {
        allContentfulCampaignConfiguration(
          filter: { campaignKey: { eq: "ladestationinfrastruktur" } }
        ) {
          nodes {
            ...campaignNavigationFragment
          }
        }
      }
    `);

  return allContentfulCampaignConfiguration;
};
